const appendQueryParams = (url: string, params: Record<string, string>): string => {
  const queryString = new URLSearchParams(params).toString();
  return `${url}${url.includes('?') ? '&' : '?'}${queryString}`;
};

export const formatYouTubeURL = (url = ""): string | undefined => {
  const rx = /^.*(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/|watch\?v(?:i)?=|&v(?:i)?=)([^#&?]*).*/;
  const match = url.match(rx);

  return match ?
    appendQueryParams(`https://www.youtube.com/embed/${match[1]}`, {
      feature: "oembed",
      wmode: "opaque",
      loop: "0",
      controls: "1",
      mute: "0",
      rel: "0",
      modestbranding: "1"
    })
    : undefined;
};

export const formatMatterportURL = (url = ""): string | undefined => {
  return url.includes("matterport.com/show/?m=") ?
    appendQueryParams(url, {
      play: "1",
      help: "0",
      brand: "0",
      dh: "0",
      gt: "1",
      hr: "0",
      ml: "2",
      mt: "0"
    })
    : undefined;
};

export const formatVimeoURL = (url = ""): string | undefined => {
  if (!url.includes("vimeo.com/")) return undefined;
  const segments = url.split("/");
  const videoId = segments[segments.length - 1];

  return appendQueryParams(`https://player.vimeo.com/video/${videoId}`, {
    title: "0",
    byline: "0",
    portrait: "0"
  });
};

export const formatVirtualToursCreatorURL = (url = ""): string | undefined => {
  return url.includes("vtc.virtualtourscreator.com.au/share/") ? url : undefined;
};

export const formatSmartViewMedia = (url = ""): string | undefined => {
  return url.includes("ss.smartviewmedia.com.au") ? url : undefined;
};
const formatters = [
  formatYouTubeURL,
  formatMatterportURL,
  formatVimeoURL,
  formatVirtualToursCreatorURL,
  formatSmartViewMedia
];

export const getEmbedURL = (url: string): string | undefined => {
  for (const formatter of formatters) {
    const embedURL = formatter(url);
    if (embedURL) return embedURL;
  }
  return undefined;
};